import { Box } from "@mui/material"
import { ReactNode } from "react"
import { StyledLabel, StyledScrollBox } from "./ScrollableListSection.styled"

interface ScrollableListSectionProps {
  label: string
  children: ReactNode
  count?: number
  maxHeight?: number | string
}

const ScrollableListSection = ({ label, children, count, maxHeight = 210 }: ScrollableListSectionProps) => (
  <Box>
    <StyledLabel variant="labelMedium">
      {label}
      {count !== undefined && ` (${count})`}
    </StyledLabel>
    <StyledScrollBox aria-label={label} tabIndex={0} sectionMaxHeight={maxHeight}>
      {children}
    </StyledScrollBox>
  </Box>
)

export default ScrollableListSection
